/**
 * 设备管理
 */
 import axios from '../request';
 export default{
    /**
     * 生产采集设备
     *
     */
    // 查询设备列表信息
    searchProductDevice: params =>
        axios.post('/engineering/device/deviceList', params),
    // 添加设备信息
    insertProductDevice: params =>
        axios.post('/engineering/device/deviceInsert', params),
    // 修改设备信息
    updateProductDevice: params =>
        axios.post('/engineering/device/deviceUpdate', params),
    // 设备信息详情
    detailsProductDevice: params =>
        axios.get('/engineering/device/deviceInfo', {params}),
    // 删除设备信息
    deleteProductDevice: params =>
        axios.get('/engineering/device/deviceDel', {params}),

    /**
     * 视频监控
     */
    // 查询视频列表信息
    searchDeviceInfo: params =>
        axios.post('/materials/video/webVideoList', params),
    // 添加视频信息
    insertDeviceInfo: params =>
        axios.post('/engineering/video/videoInsert', params),
    // 修改视频信息
    updateDeviceInfo: params =>
        axios.post('/engineering/video/videoUpdate', params),
    // 视频信息详情
    detailsDeviceInfo: params =>
        axios.get('/engineering/video/videoInfo', {params}),
    // 删除视频信息
    deleteDeviceInfo: params =>
        axios.get('/engineering/video/videoDel', {params}),
    //返回视频播放地址
    backVideosUrlList: params =>
        axios.post('/materials/video/videoListPath', params),

    /**
     * 大型生产设备
     */
    // 查询大型生产设备列表信息
    searchBigDevice: params =>
        axios.post('/engineering/bigDevice/bigDeviceList', params),
    // 添加大型生产设备信息
    insertBigDevice: params =>
        axios.post('/engineering/bigDevice/bigDeviceInsert', params),
    // 修改大型生产设备信息
    updateBigDevice: params =>
        axios.post('/engineering/bigDevice/bigDeviceUpdate', params),
    // 大型生产设备信息详情
    detailsBigDevice: params =>
        axios.get('/engineering/bigDevice/bigDeviceInfo', {params}),
    // 删除大型生产设备信息
    deleteBigDevice: params =>
        axios.get('/engineering/bigDevice/bigDeviceDel', {params}),
    //大型生产设备下拉
    getAllBigDevice: params =>
        axios.get('/engineering/bigDevice/bigDevicePull', {params}),
    //导出数据
    exportBigDatas:params=>
        axios({
            method: 'post',
            url: '/engineering/bigDevice/bigDeviceExcel',
            responseType: 'blob',
            data: params
        }),

    /**
     * 设备检查
     */

    // 设备检查列表信息
    searchCheckDevice: params =>
        axios.post('/engineering/bigInspect/bigInspectList', params),
    // 添加设备检查信息
    insertCheckDevice: params =>
        axios.post('/engineering/bigInspect/bigInspectInsert', params),
    // 修改设备检查信息
    updateCheckDevice: params =>
        axios.post('/engineering/bigInspect/bigInspectUpdate', params),
    // 设备检查信息详情
    detailsCheckDevice: params =>
        axios.get('/engineering/bigInspect/bigInspectInfo', {params}),
    // 删除设备检查信息
    deleteCheckDevice: params =>
        axios.get('/engineering/bigInspect/bigInspectDel', {params}),

    /**
     * 设备保养
     */

    // 设备保养列表信息
    searchKeepDevice: params =>
        axios.post('/engineering/maintenance/maintenanceList', params),
    // 添加设备保养信息
    insertKeepDevice: params =>
        axios.post('/engineering/maintenance/maintenanceInsert', params),
    // 修改设备保养信息
    updateKeepDevice: params =>
        axios.post('/engineering/maintenance/maintenanceUpdate', params),
    // 设备保养详情
    detailsKeepDevice: params =>
        axios.get('/engineering/maintenance/maintenanceInfo', {params}),
    // 删除设备保养信息
    deleteKeepDevice: params =>
        axios.get('/engineering/maintenance/maintenanceDel', {params}),

    /**
     * 设备维修
     */
    // 设备维修列表信息
    searchServiceDevice: params =>
        axios.post('/engineering/overhaul/overhaulList', params),
    // 添加设备维修信息
    insertServiceDevice: params =>
        axios.post('/engineering/overhaul/overhaulInsert', params),
    // 修改设备维修信息
    updateServiceDevice: params =>
        axios.post('/engineering/overhaul/overhaulUpdate', params),
    // 设备维修详情
    detailsServiceDevice: params =>
        axios.get('/engineering/overhaul/overhaulInfo', {params}),
    // 删除设备维修信息
    deleteServiceDevice: params =>
        axios.get('/engineering/overhaul/overhaulDel', {params}),
 }